import Layout from "../../layout/Layout";
import ShipmentLiveCameras from "../sevkiyat/ShipmentLiveCameras";

function SevkiyatLiveCameraPage() {
  return (
    <Layout>
      <div className="shipment-camera-page">
        <div className="mb-4">
          <h3 className="fw-bold m-0">Sevkiyat Canlı Kameraları</h3>
          <small className="text-muted">
            Sevkiyat yükleme alanlarını canlı olarak takip edin.
          </small>
        </div>

        <ShipmentLiveCameras standalone />
      </div>
    </Layout>
  );
}

export default SevkiyatLiveCameraPage;
